'use client';

import { c as _c } from "react/compiler-runtime";
import { checkAccess, useAuth } from '@repo/auth';
import { TEST_IDS } from '@repo/sdk/constants';
import { permissions, roleNames } from '@repo/permissions';
import type { CommandWorkflowLinkNode } from '@repo/shortcuts/command';
import { useMemo } from 'react';
type RouteItem = {
  access: {
    match: 'any';
    permissions: string[];
    roles: string[];
  };
  href: `/${string}`;
  keywords: string[];
  label: string;
  shortcut?: string;
  testId?: string;
  value: string;
};
const routes: RouteItem[] = [{
  access: {
    match: 'any',
    permissions: [permissions.loads.list],
    roles: [roleNames.superAdmin]
  },
  href: '/loads',
  keywords: ['loads', 'orders', 'shipments', 'go to', 'goto'],
  label: 'Go to Loads',
  shortcut: 'G L',
  testId: TEST_IDS.cmdk.navigation.loads,
  value: 'loads'
}, {
  access: {
    match: 'any',
    permissions: [permissions.companies.view],
    roles: [roleNames.superAdmin]
  },
  href: '/management/customers',
  keywords: ['customers', 'shippers', 'clients', 'go to', 'goto'],
  label: 'Go to Customers',
  shortcut: 'G C',
  testId: TEST_IDS.cmdk.navigation.shippers,
  value: 'customers'
}, {
  access: {
    match: 'any',
    permissions: [permissions.companies.view],
    roles: [roleNames.superAdmin]
  },
  href: '/management/carriers',
  keywords: ['carriers', 'haulers', 'hauliers', 'trucks', 'go to', 'goto'],
  label: 'Go to Carriers',
  value: 'carriers'
}, {
  access: {
    match: 'any',
    permissions: [permissions.companies.view],
    roles: [roleNames.superAdmin]
  },
  href: '/management/brokers',
  keywords: ['brokers', 'forwarders', 'go to', 'goto'],
  label: 'Go to Brokers',
  value: 'brokers'
}, {
  access: {
    match: 'any',
    permissions: [permissions.companies.view],
    roles: [roleNames.superAdmin]
  },
  href: '/management/other-companies',
  keywords: ['other companies', 'misc', 'go to', 'goto'],
  label: 'Go to Other companies',
  value: 'other-companies'
}, {
  access: {
    match: 'any',
    permissions: [permissions.users.list],
    roles: [roleNames.superAdmin]
  },
  href: '/management/users',
  keywords: ['users', 'people', 'staff', 'go to', 'goto'],
  label: 'Go to Users',
  shortcut: 'G U',
  testId: TEST_IDS.cmdk.navigation.users,
  value: 'users'
}, {
  access: {
    match: 'any',
    permissions: [permissions.permissionGroups.list],
    roles: [roleNames.superAdmin]
  },
  href: '/management/users/roles',
  keywords: ['permissions', 'roles', 'access', 'go to', 'goto'],
  label: 'Go to Permissions',
  shortcut: 'G P',
  value: 'permissions'
}];
export const useRouteCatalog = () => {
  const $ = _c(2);
  const {
    user
  } = useAuth();
  let t0;
  if ($[0] !== user) {
    t0 = routes.filter(route => checkAccess(user, route.access).allowed).map(_temp);
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(route_0) {
  return {
    href: route_0.href,
    id: route_0.value,
    keywords: route_0.keywords,
    kind: "link" as const,
    label: route_0.label,
    shortcut: route_0.shortcut,
    testId: route_0.testId,
    value: route_0.value
  };
}